import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ForuscareService } from '../foruscare/foruscare.service';
import { Account } from '../../models/account';
import { serviceWorkflow } from '../../models/service';
import { MRNConfig } from 'src/app/models/mrnConfig';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  private handleError: HandleError;

  constructor(
    public http: HttpClient,
    public fourscareService: ForuscareService,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('Account Service');
  }


  getOperatorListByAccountAndScreeningCenter(screeningCenters: any) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/admin/user/getAllUsersByOrgIds", screeningCenters)
      .pipe(
        catchError(this.handleError("Screening Events creation and updation failed"))
      );
  }

  getUserScheduledAppointmentsByUserId(userId: any, count: any, offset: any) {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/appointment/schduledAppointmentsByUser/" + userId + "?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError("Screening Events creation and updation failed"))
      );
  }

  getAppointmentsDataByFilter(data: any) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/appointment/getAppointmentsDataByFilter", data)
      .pipe(
        catchError(this.handleError("Something went wrong! please try aganin later"))
      );
  }

  cancelAppointmentsById(data: any) {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/appointment/cancelByFilter", data)
      .pipe(
        catchError(this.handleError("Something went wrong! please try aganin later"))
      );
  }

  getAvailableDatesOfScreeningEventAndScreeningCenter(eventDetails: any) {
    return this.http.post(this.fourscareService.baseAuthURL() + "/slotConfig/availableSlotsTime/organization", eventDetails)
      .pipe(
        catchError(this.handleError("Unable to update corrected visual acuity"))
      )
  }

  getSlotsbyOrgId(orgId: any, slotDate: any): any {
    return this.http.post(this.fourscareService.baseAuthURL() + "/slotConfig/users/appointmentDateAndOrganization/" + orgId,
      slotDate)
      .pipe(
        catchError(this.handleError("unable to get the details"))
      );
  }

  getSlotTimings(data: any): any {
    return this.http.post(this.fourscareService.baseAuthURL() + "/slotConfig/slotsAvailableByUserIdAndDate", data)
      .pipe(
        catchError(this.handleError("unable to get the details"))
      );
  }

  rescheduleAppointment(appointmentId: any, rescheduleDetails: any) {
    return this.http.put(this.fourscareService.baseAuthURL() + "/appointment/reschedule/" + appointmentId, rescheduleDetails)
      .pipe(
      // catchError(this.handleError("Unable to update corrected visual acuity"))
    )
  }

  getCustomTemplates() {
    return this.http.get(this.fourscareService.baseAuthURL() + "/appointment/customTemplates")
      .pipe(
      // catchError(this.handleError("Unable to update corrected visual acuity"))
    )
  }

  sendCustomNotifications(payload: any) {
    return this.http.post(this.fourscareService.baseAuthURL() + "/appointment/addCustomNotificationsByFilter", payload)
      .pipe(
      // catchError(this.handleError("Unable to update corrected visual acuity"))
    )
  }
}
